import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import logo from '../assets/image/logo.png'


const Footer = () => {
    return (
        <FooterWrap>
          <FooterElement>
            <div className='logo_container'>
                <img src={logo} alt="" />
            </div>
            <div className="menu_container">
                <label className="container_label">
                    Menu
                </label>
                <div className="menuBtnContainer">
                    <MenuBtnLink className="active" to="/">
                        Home
                    </MenuBtnLink>
                    <MenuBtnLink className="active" to="/events">
                        Event
                    </MenuBtnLink>
                    <MenuBtnLink className="active" to="/chat">
                        Message
                    </MenuBtnLink>
                    <MenuBtnLink className="active" to="/notification">
                        Notification
                    </MenuBtnLink>
                    <MenuBtnLink className="active" to="/like">
                        Like
                    </MenuBtnLink>
                    <MenuBtnLink className="active" to="/profile">
                        Profile
                    </MenuBtnLink>
                    <MenuBtnLink className="active" to="/help">
                        Help
                    </MenuBtnLink>
                </div>
            </div>
            <div className="address">
            <label className="container_label">
                    Head Office
                </label>
                <div className='addressLine_cont'>
                     <p className='address_txt'>Address- 2118 Thornridge Cir. Syracuse, Connecticut 35624</p>
                     <p className='address_txt'>Call -(603) 555-0123, (603) 555-0124</p>
                     <p className='address_txt'>Email-support@studio.com</p>
                </div>
            </div>
          </FooterElement>
        </FooterWrap>
    )
}

export default Footer

const FooterWrap = styled.div`
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.background};

    

`
const FooterElement = styled.div`
    display: flex;
    justify-content: space-between;
    height: 70vh;

    @media  screen and (max-width: 768px) {
        flex-direction: column;
        height: fit-content;
        align-items: center;
    }


    .logo_container{
        width: 20rem;
        display: flex;
        height: 80%;
        align-items: center;
        justify-content: center;
        img {
            width: 10rem;

            @media(max-width: 768px){
                width: 5rem;
                margin-top: 1rem;
            }
        }
    }


    .container_label{
        color: ${({ theme }) => theme.text}; 
    font-family: Montserrat;
font-weight: 600;
font-size: 1rem;
margin: 1.5rem 0rem;
text-decoration: none;
    }
    .menu_container{
        display: flex;
        flex-direction: column;
        width: 30rem;
        height: 80%;

        @media  screen and (max-width: 768px) {
            width: 80%;   

        }
    }
    .menuBtnContainer{
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 18rem;
        /* justify-content: space-between; */
    }

    .address {
        display: flex;
        width: 20rem;
        flex-direction: column;
        height: 80%;
    }

    .addressLine_cont{
        display: flex;
        
        justify-content: space-evenly;
        flex-direction: column;
        p{
            color: ${({ theme }) => theme.text}; 
    font-family: Montserrat;
font-weight: 400;
font-size: 1rem;
margin: 1.5rem 0rem;
text-decoration: none;
        }
    }
`

const MenuBtnLink = styled(NavLink)`
    color: ${({ theme }) => theme.text}; 
    font-family: Montserrat;
font-weight: 400;
font-size: 1rem;
margin: 1.5rem 0rem;
text-decoration: none;
    .active {
        color: ${({ theme }) => theme.primaryText};    
    }
`